import { render } from "./Accordion.vue?vue&type=template&id=2df3da9e&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=2df3da9e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df3da9e"]])

export default __exports__